import http from "./http-common"
import {Plan} from "../types/domain";

/**
 * Service class for the Plan type
 * @author KMU
 */
class PlanService {
    url = `/plans/`;

    getAll() {
        return http.get<Array<Plan>>(this.url + `getAll`);
    }

    get(id: number) {
        return http.get<Plan>(this.url + `${id}`);
    }

    getByUsername(username: string | undefined) {
        return http.get<Array<Plan>>(this.url + `getByUsername/${username}`);
    }

    /**
     * Create new Plan entity with it's Planexercise entities
     * is used for creating duplicates
     * @param plan plan entity with general information
     * @param exercises list of exercises for this plan
     * @return boolean whether creation was successful or not
     */
    createWholePlan(plan: Plan) {
        return http.post<Plan>(this.url + `createWholePlan`, plan);
    }

    createWholePlanWithAttachments(formData: FormData) {
        return http.post<Plan>(this.url + `createWithAttachments`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
    }

    updateWholePlanWithAttachments(formData: FormData) {
        return http.put(this.url + `updateWithAttachments`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
    }

    delete(id: number) {
        return http.delete<any>(this.url + `${id}`);
    }
}

export default new PlanService();